import React from "react";
import Skeleton from "react-loading-skeleton";

const NotificationsLoading = () => {
  return (
    <div className="p-2">
      <div className="flex justify-center align-center space-between mb-1">
        <div>
          <h4>Notifications</h4>
          <Skeleton count={1} style={{ width: 300 }} />
        </div>
        <Skeleton height={36} width={130} style={{ borderRadius: 6 }} />
      </div>
      <Skeleton
        count={6}
        style={{ height: "10vh", marginBottom: 10, borderRadius: 10 }}
      />
    </div>
  );
};

export default NotificationsLoading;
